var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.505 11.008A4.508 4.508 0 0 1 2 6.505 4.509 4.509 0 0 1 6.505 2a4.509 4.509 0 0 1 4.503 4.504 4.509 4.509 0 0 1-4.503 4.503m9.214 3.296l-3.967-3.967a6.47 6.47 0 0 0 1.257-3.832 6.505 6.505 0 1 0-6.504 6.504 6.47 6.47 0 0 0 3.832-1.257l3.967 3.967a1 1 0 0 0 1.415-1.415",
    fill: "#8093A6",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSearchIcon);
export default __webpack_public_path__ + "static/media/menu-search-icon.21c5e3066bd2222a68d3e58fa8d8e6cb.svg";
export { ForwardRef as ReactComponent };